import { render, staticRenderFns } from "./EventItem.vue?vue&type=template&id=7bafb3cf&scoped=true&"
import script from "./EventItem.vue?vue&type=script&lang=js&"
export * from "./EventItem.vue?vue&type=script&lang=js&"
import style0 from "./EventItem.vue?vue&type=style&index=0&id=7bafb3cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bafb3cf",
  null
  
)

export default component.exports